export enum rawModes {
    tms = 'tms',
    pms = 'pms',
    alarm1s = 'alarm1s',
    alarm2s = 'alarm2s',
    alarm3s = 'alarm3s',
    alarm4s = 'alarm4s',
    alarm5s = 'alarm5s',
    alarm6s = 'alarm6s',
}
